var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPersonTeal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6153 13.1911C14.6153 10.0048 17.1983 7.42188 20.3846 7.42188C23.5708 7.42188 26.1538 10.0048 26.1538 13.1911C26.1538 16.3774 23.5708 18.9603 20.3846 18.9603C17.1983 18.9603 14.6153 16.3774 14.6153 13.1911Z",
    fill: "#06799B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.80923 31.2749C9.90838 25.5188 14.605 20.8834 20.3846 20.8834C26.1642 20.8834 30.8609 25.519 30.9599 31.2753C30.9664 31.657 30.7465 32.0065 30.3995 32.1657C27.3496 33.5652 23.957 34.345 20.385 34.345C16.8126 34.345 13.4197 33.5651 10.3696 32.1653C10.0226 32.0061 9.80265 31.6566 9.80923 31.2749Z",
    fill: "#06799B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPersonTeal);
export default __webpack_public_path__ + "static/media/Icon_Person_Teal.5e73e19366576cadc5e94e6eb5ef94c2.svg";
export { ForwardRef as ReactComponent };